import { render } from "./index.vue?vue&type=template&id=ff9966c8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ff9966c8&lang=scss"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lidu/礼度管理后台-申办方端【生产】/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__